
import { Vue } from "vue-class-component";
import { useStore } from "vuex";

export default class Alert extends Vue {
  globalStore = useStore();

  infoTitle() {
    return this.globalStore.state.info.title;
  }

  infoText() {
    return this.globalStore.state.info.text;
  }

  successTitle() {
    return this.globalStore.state.success.title;
  }

  successText() {
    return this.globalStore.state.success.text;
  }

  warningTitle() {
    return this.globalStore.state.warning.title;
  }

  warningText() {
    return this.globalStore.state.warning.text;
  }

  isWarningConfirmation() {
    return this.globalStore.state.warning.isConfirmation;
  }

  dangerTitle() {
    return this.globalStore.state.danger.title;
  }

  dangerText() {
    return this.globalStore.state.danger.text;
  }

  fecha(type: string) {
    console.log("fecha", type);
    this.globalStore.commit("close", { type: type });
  }

  confirm(type: string) {
    try {
      this.globalStore.state[type]?.onConfirm?.();
    } catch (e) {
      console.error(e);
    }
    this.fecha(type);
  }

  cancel(type: string) {
    this.globalStore.state[type]?.onCancel?.();
    this.fecha(type);
  }

  check(type: string) {
    if (type === "info") return this.globalStore.state.info.opened;
    if (type === "success") return this.globalStore.state.success.opened;
    if (type === "warning") return this.globalStore.state.warning.opened;
    if (type === "danger") return this.globalStore.state.danger.opened;
  }
}
